import './App.css';
import Intro from './Intro/Intro';
import { Container } from '@mui/material';

function App() {
    return <Container maxWidth="md"><Intro/></Container>;
}

export default App;
